import { useFormik } from 'formik';
import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import Checks, { ChecksGroup } from '../../bootstrap/forms/Checks';
import FormGroup from '../../bootstrap/forms/FormGroup';
import Input from '../../bootstrap/forms/Input';
import Label from '../../bootstrap/forms/Label';
import Textarea from '../../bootstrap/forms/Textarea';
import Modal, { ModalBody, ModalHeader, ModalTitle } from '../../bootstrap/Modal';
// Database
import { DefaultContext } from '../../../contexts/default';
import ComplementDB from '../../../database/wrappers/complement';
import masks, { unmask } from '../../../helpers/utils/masks';
import Money from '../../../helpers/utils/money/money';
import PreAlert from '../../../helpers/utils/preAlert';
import { convertTrybuIntToPTBR, TRIBUTARY_SITUATION } from '../../../types/fiscal';
import { CardBody } from '../../bootstrap/Card';
import Select from '../../bootstrap/forms/Select';
import Avatar from '../../MyCustom/Avatar';
import Wizard, { WizardItem } from '../../Wizard';
import UserHistory from '../../../database/wrappers/userHistory';
import { getCompatibleUnits, convertGramaToKg } from '../../../utils/cmv/convertQtd';
import Button from '../../bootstrap/Button';
import InsumosDB from '../../../database/wrappers/insumos';
import tabela_ncm from '../../../utils/fiscal/nfce/tabela_ncm.json';
import tabela_cest from '../../../utils/fiscal/nfce/tabela_cest.json';
import tabela_cfop from '../../../utils/fiscal/nfce/tabela_cfop.json';
import FiscalGroupDB from '../../../database/wrappers/fiscalGroup';
import { orderBy } from 'firebase/firestore';

const officialCESTCodes = tabela_cest.map(item =>
  item.CEST.replace(/\D/g, '')
);

const officialCFOPCodes = tabela_cfop.map(item =>
  item.cfop.replace(/\D/g, '')
);

const officialNCMCodes = (tabela_ncm).Nomenclaturas.map((item) =>
  item.Codigo.replace(/\D/g, '')
);
const genericCEST = ['0000000'];

const validCST = [
  '00', '10', '20', '30', '40', '41', '50', '51', '60', '70', '90'
];

const brazilStates = [
  'AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO',
  'MA', 'MT', 'MS', 'MG', 'PA', 'PB', 'PR', 'PE', 'PI',
  'RJ', 'RN', 'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO',
].map(state => ({ value: state, text: state }));

const validate = (values) => {
  const errors = {};

  if (values.fiscal_data_pRedICMS !== '') {
    const pRedICMS = Number(String(values.fiscal_data_pRedICMS).replace(',', '.'));
    if (!Number.isFinite(pRedICMS) || pRedICMS < 0 || pRedICMS > 100) {
      errors.fiscal_data_pRedICMS = 'Informe um percentual entre 0 e 100';
    }
  }

  if (!values.name) {
    errors.name = 'Este campo é necessário';
  }

  const price = unmask(values.price);
  if (isNaN(Number(price)) || Number(price) < 0) {
    errors.price = "Informe um preço válido";
  }

  if (!values.active) {
    errors.active = 'Você precisa escolher o status do complemento';
  }


  // Informaçoes Fiscais
  //  if (!values.fiscal_data_bar_code) {
  //   errors.fiscal_data_bar_code = 'Este campo é necessário';
  // }
  if (!values.fiscal_data_ncm) {
    errors.fiscal_data_ncm = 'Este campo é necessário';
  }

  if (!officialNCMCodes.includes(values.fiscal_data_ncm) && !['00000000'].includes(values.fiscal_data_ncm)) {
    errors.fiscal_data_ncm = 'NCM inexistente';
  }
  if (!values.fiscal_data_cst) {
    errors.fiscal_data_cst = 'Este campo é necessário';
  }

  if (!validCST.includes(values.fiscal_data_cst)) {
    errors.fiscal_data_cst = 'CST inexistente';
  }

  if (!officialCFOPCodes.includes(values.fiscal_data_cfop)) {
    errors.fiscal_data_cfop = 'CFOP Inexistente';
  }

  if (!officialCESTCodes.includes(values.fiscal_data_cest) && !genericCEST.includes(values.fiscal_data_cest)) {
    errors.fiscal_data_cest = 'CEST Inexistente';
  }

  if (!values.fiscal_data_cfop) {
    errors.fiscal_data_cfop = 'Este campo é necessário';
  }
  if (!Object.keys(TRIBUTARY_SITUATION).find(key => TRIBUTARY_SITUATION[key] == values.fiscal_data_tributary_situation)) {
    errors.fiscal_data_tributary_situation = 'Selecione uma opção necessário';
  }

  const fiscalGroupsByState = Array.isArray(values.fiscal_groups_by_state) ? values.fiscal_groups_by_state : [];
  const seenStates = new Map();
  fiscalGroupsByState.forEach((item, index) => {
    const state = item?.state;
    const fiscalGroupId = item?.fiscal_group_id;

    if ((state && !fiscalGroupId) || (!state && fiscalGroupId)) {
      if (!Array.isArray(errors.fiscal_groups_by_state)) errors.fiscal_groups_by_state = [];
      errors.fiscal_groups_by_state[index] = {
        ...(errors.fiscal_groups_by_state[index] || {}),
        ...(state && !fiscalGroupId ? { fiscal_group_id: 'Selecione o grupo fiscal' } : {}),
        ...(!state && fiscalGroupId ? { state: 'Selecione o estado' } : {}),
      };
    }

    if (!state) return;
    if (seenStates.has(state)) {
      const firstIndex = seenStates.get(state);
      if (!Array.isArray(errors.fiscal_groups_by_state)) errors.fiscal_groups_by_state = [];
      errors.fiscal_groups_by_state[firstIndex] = {
        ...(errors.fiscal_groups_by_state[firstIndex] || {}),
        state: 'Estado já selecionado em outra linha',
      };
      errors.fiscal_groups_by_state[index] = {
        ...(errors.fiscal_groups_by_state[index] || {}),
        state: 'Estado já selecionado em outra linha',
      };
      return;
    }
    seenStates.set(state, index);
  });

  return errors;

}


const ModalRegisterComplement = ({ open, setIsOpen, setIsClose, complementSelected }) => {

  const { establishment, settings, onShowAlert, user } = useContext(DefaultContext);
  const [isLoading, setIsLoading] = useState(false);
  //gerenciamento de insumos
  const [insumes, setInsumes] = useState([]);
  const [insumeToProduct, setInsumeToProduct] = useState([]);
  const [compatibleUnits, setCompatibleUnits] = useState([]);
  const [fiscalGroups, setFiscalGroups] = useState([]);

  useEffect(() => {
    if (!establishment) return;
    return new FiscalGroupDB(establishment.id).on(setFiscalGroups, orderBy('name', 'asc'));
  }, [establishment]);

  useEffect(() => {
    if (!open) {
      formik.resetForm();
      setInsumeToProduct([]);
      setCompatibleUnits([]);
      return;
    }
    if (complementSelected) {
      const {
        name, secondName, sku, price, description, active, fiscal_data,
        order, image_url, second_image_url, orderDelivery, delivery_code,
        unit, type_insume, insumes, fiscal_groups_by_state
      } = complementSelected;

      setInsumeToProduct(insumes !== undefined ? insumes : []);


      formik.setValues({
        name: name,
        secondName: secondName === undefined ? '' : secondName,
        sku: sku === undefined ? '' : sku,
        price: Money.centsToCoin(price).toFixed(2),
        description: description || '',
        active: active ? 'ativo' : 'inativo',
        image: null, // Image file is not reloaded, only URL
        image_url: image_url || null,
        second_image: null,
        type_insume: type_insume ? ['check'] : [],
        second_image_url: second_image_url === undefined ? null : second_image_url,
        unit: unit,
        order: order === undefined ? null : order,
        orderDelivery: orderDelivery ? orderDelivery : null,
        delivery_code: delivery_code || null,
        fiscal_groups_by_state: Array.isArray(fiscal_groups_by_state) && fiscal_groups_by_state.length > 0
          ? fiscal_groups_by_state
          : [{ state: '', fiscal_group_id: '' }],
        // fiscal data
        fiscal_data_pis: fiscal_data?.pis ?? '',
        fiscal_data_cofins: fiscal_data?.cofins ?? '',
        fiscal_data_cBenef: fiscal_data?.cBenef ?? '',
        fiscal_data_cClassTrib: fiscal_data?.cClassTrib ?? '',
        fiscal_data_percentualReducao: fiscal_data?.percentualReducao ?? '',
        fiscal_data_pRedICMS: fiscal_data?.pRedICMS ?? '',
        fiscal_data_cst_cbs_ibs: fiscal_data?.cst_cbs_ibs ?? '',
        fiscal_data_bar_code: fiscal_data?.bar_code ?? '',
        fiscal_data_ncm: fiscal_data?.ncm,
        fiscal_data_cst: fiscal_data?.cst,
        fiscal_data_csosn: fiscal_data?.csosn,
        fiscal_data_cest: fiscal_data?.cest,
        fiscal_data_cfop: fiscal_data?.cfop,
        fiscal_data_aliq_icms: fiscal_data?.aliq_icms ? fiscal_data?.aliq_icms : '',
        fiscal_data_tributary_situation: fiscal_data?.tributary_situation,
      });
    }
  }, [complementSelected, open]);

  useEffect(() => {
    if (establishment?.id) {
      const onSubscribe = new InsumosDB(establishment.id).on(setInsumes);
      return () => {
        if (typeof onSubscribe === 'function') {
          onSubscribe();
        }
      };
    }
  }, [establishment]);

  const { listedInsumes, noListedInsumes } = useMemo(() => {
    const listed = [];
    const notListed = [];

    insumes.forEach(insume => {
      const isAdded = insumeToProduct.some(productInsume => productInsume.insume === insume.id);
      if (isAdded) {
        listed.push(insume);
      } else {
        notListed.push(insume);
      }
    });

    const sortByName = (a, b) => (a.text || a.name).localeCompare(b.text || b.name);

    return {
      listedInsumes: listed
        .map(item => ({ value: item.id, text: item.name, unit: item.unit }))
        .sort(sortByName),
      noListedInsumes: notListed
        .map(item => ({ value: item.id, text: item.name, unit: item.unit }))
        .sort(sortByName),
    };
  }, [insumes, insumeToProduct]);

  const formik = useFormik({
    initialValues: {
      name: '',
      secondName: '',
      sku: '',
      value: '',
      price: '',
      description: '',
      active: '',
      order: '',
      orderDelivery: '',
      delivery_code: '',
      unit: '',
      image: null,
      image_url: null,
      second_image: null,
      second_image_url: null,
      fiscal_groups_by_state: [{ state: '', fiscal_group_id: '' }],

      // fiscal data
      fiscal_data_bar_code: '',
      fiscal_data_ncm: '',
      fiscal_data_cst: '',
      fiscal_data_csosn: '',
      fiscal_data_cest: '',
      fiscal_data_cfop: '',
      fiscal_data_aliq_icms: '',
      fiscal_data_tributary_situation: '',
      fiscal_data_pis: '',
      fiscal_data_cofins: '',
      fiscal_data_cBenef: '',
      fiscal_data_cClassTrib: '',
      fiscal_data_percentualReducao: '',
      fiscal_data_pRedICMS: '',
      fiscal_data_cst_cbs_ibs: '',

      insume_qtd: '',
      insume_unit: '',
      insume: '',
      insumes: [],
      type_insume: [],
    },
    validate,
    onSubmit: values => {
      const {
        name,
        secondName,
        sku,
        description,
        price,
        active,
        image,
        second_image,
        order,
        orderDelivery,
        delivery_code,
        unit,
        type_insume,

        fiscal_data_bar_code,
        fiscal_data_ncm,
        fiscal_data_cst,
        fiscal_data_csosn,
        fiscal_data_cest,
        fiscal_data_cfop,
        fiscal_data_aliq_icms,
        fiscal_data_tributary_situation,
        fiscal_data_cofins,
        fiscal_data_pis,
        fiscal_data_cBenef,
        fiscal_data_cClassTrib,
        fiscal_data_percentualReducao,
        fiscal_data_pRedICMS,
        fiscal_data_cst_cbs_ibs,
        fiscal_groups_by_state,
      } = values;

      const fiscal_data = {
        pis: fiscal_data_pis,
        cofins: fiscal_data_cofins,
        cBenef: fiscal_data_cBenef ?? '',
        cClassTrib: fiscal_data_cClassTrib ?? '',
        percentualReducao: fiscal_data_percentualReducao ?? '',
        pRedICMS: String(fiscal_data_pRedICMS ?? '').replace(',', '.'),
        cst_cbs_ibs: fiscal_data_cst_cbs_ibs ?? '',
        bar_code: fiscal_data_bar_code ?? '',
        ncm: fiscal_data_ncm,
        cst: fiscal_data_cst,
        csosn: fiscal_data_csosn,
        cest: fiscal_data_cest,
        cfop: fiscal_data_cfop,
        aliq_icms: fiscal_data_aliq_icms === undefined ? null : fiscal_data_aliq_icms.replace(',', '.'),
        tributary_situation: fiscal_data_tributary_situation
      };

      const insumesDataForDb = type_insume.includes('check') && insumeToProduct ? insumeToProduct.map(item => ({
        insume: item.insume,
        name: item.name,
        qtd: convertGramaToKg(item.unit, Number(item.qtd)),
        unit: item.unit,
      })) : [];

      const data = {
        name,
        secondName: secondName === undefined ? null : secondName,
        sku: sku === undefined ? null : sku,
        price: Number(unmask(price)),
        description: description === undefined ? null : description,
        active: active === 'ativo',
        type_insume: type_insume.includes('check') || null,
        order: order ? Number(order) : null,
        orderDelivery: orderDelivery ? Number(orderDelivery) : null,
        delivery_code: delivery_code || null,
        unit: unit || 'UN',
        image,
        second_image,
        fiscal_data,
        fiscal_groups_by_state: (Array.isArray(fiscal_groups_by_state) ? fiscal_groups_by_state : [])
          .filter(item => item?.state && item?.fiscal_group_id)
          .map(item => ({ state: item.state, fiscal_group_id: item.fiscal_group_id })),
        insumes: insumesDataForDb,
      };

      console.log("Dados a serem salvos (Complemento):", data);

      const onSuccess = () => {
        onShowAlert(PreAlert.success('Registro cadastrado com sucesso'));
        setIsClose();
      };
      const onSuccessUpdate = () => {
        onShowAlert(PreAlert.success('Registro atualizado com sucesso'));
        setIsClose();
      };
      const onError = (error) => {
        console.error("Erro ao salvar complemento:", error);
        onShowAlert(PreAlert.error('Falhou ao cadastrar/atualizar o registro'));
      };

      setIsLoading(true);
      if (complementSelected) {
        new ComplementDB(establishment.id)
          .update(complementSelected.id, data)
          .then(() => {
            onSuccessUpdate();
            new UserHistory(establishment.id, user, "o Complemento")
              .update(complementSelected.id, { data, selected: complementSelected })
              .finally(() => { });
          })
          .catch(onError)
          .finally(() => setIsLoading(false));
      } else {
        new ComplementDB(establishment.id)
          .create(data)
          .then(() => {
            onSuccess();
            new UserHistory(establishment.id, user, "o Complemento")
              .create(data)
              .finally(() => { });
          })
          .catch(onError)
          .finally(() => setIsLoading(false));
      }
    },
  });



  const checkStepIsValid = (step) => {
    if (step === 'step1') {
      const priceVal = unmask(formik.values.price);
      if (
        formik.values.name !== '' &&
        formik.values.active !== '' &&
        formik.values.price !== '' &&
        !(isNaN(Number(priceVal)) || Number(priceVal) < 0)
      ) {
        return false;
      } else {
        return true;
      }
    }
    if (step === 'add_insumo') {
      if (
        formik.values.insume_qtd !== '' &&
        formik.values.insume_unit !== '' &&
        formik.values.insume !== '' &&
        !isNaN(Number(formik.values.insume_qtd)) && Number(formik.values.insume_qtd) > 0
      ) {
        return false;
      } else {
        return true;
      }
    }
    return false;
  };

  const handleImage = useCallback((e) => {
    const [file] = Array.from(e.target.files)
    formik.setValues({
      ...formik.values,
      image: file,
      image_url: URL.createObjectURL(file)
    })
  }, [formik.values])

  const handleImageSecond = useCallback((e) => {
    const [file] = Array.from(e.target.files)
    formik.setValues({
      ...formik.values,
      second_image: file,
      second_image_url: URL.createObjectURL(file)
    })
  }, [formik.values])

  const handleChangeOrder = useCallback(e => {
    const order = e.target.value.replace(/\D/g, "");
    formik.setValues({
      ...formik.values,
      order
    })
  }, [formik.values])

  const optionsSituation = useMemo(() => Object.keys(TRIBUTARY_SITUATION).map(key => ({ value: TRIBUTARY_SITUATION[key], text: convertTrybuIntToPTBR(TRIBUTARY_SITUATION[key]) })), []);
  const optionsFiscalGroups = useMemo(() => [
    { value: '', text: 'Selecione o grupo fiscal' },
    ...fiscalGroups.map(group => ({ value: group.id, text: group.name })),
  ], [fiscalGroups]);
  const showInsumesStep = formik.values?.type_insume?.includes('check');

  const handleAddFiscalGroupByState = useCallback(() => {
    const current = Array.isArray(formik.values.fiscal_groups_by_state) ? formik.values.fiscal_groups_by_state : [];
    const usedStates = [...new Set(current.map(item => item?.state).filter(Boolean))];
    if (usedStates.length >= brazilStates.length) return;
    formik.setFieldValue('fiscal_groups_by_state', [...current, { state: '', fiscal_group_id: '' }]);
  }, [formik.values.fiscal_groups_by_state]);

  const handleRemoveFiscalGroupByState = useCallback((index) => {
    const current = Array.isArray(formik.values.fiscal_groups_by_state) ? formik.values.fiscal_groups_by_state : [];
    const next = current.filter((_, itemIndex) => itemIndex !== index);
    formik.setFieldValue(
      'fiscal_groups_by_state',
      next.length > 0 ? next : [{ state: '', fiscal_group_id: '' }],
    );
  }, [formik.values.fiscal_groups_by_state]);

  const handleAddInsumeToProduct = () => {
    if (
      !formik.values.insume_qtd ||
      !formik.values.insume ||
      !formik.values.insume_unit


    ) return;
    setInsumeToProduct([...insumeToProduct,
    {
      qtd: formik.values.insume_qtd,
      unit: formik.values.insume_unit || 'UN',
      name: insumes.find(item => item.id === formik.values.insume)?.name || '',
      insume: formik.values.insume,
      isNew: true
    }
    ])
    formik.setFieldValue('insume_qtd', '')
    formik.setFieldValue('insume_value', '')
    formik.setFieldValue('insume', '')
    formik.setFieldValue('insume_unit', '')

  }

  const handleRemoveInsume = (index) => {
    const newInsumes = insumeToProduct.filter((item, i) => i !== index)
    setInsumeToProduct(newInsumes)
  }

  return (
    <Modal
      id={'modal-register-complement'}
      titleId={'Cadastro de Complemento'}
      isOpen={open}
      setIsOpen={setIsOpen}
      isStaticBackdrop={true}
      isScrollable={false}
      isCentered={true}
      size="lg" // 'sm' || 'lg' || 'xl'
      isAnimation={true}
    >
      <ModalHeader className='p-4 mt-2 justify-content-start' setIsOpen={setIsOpen}>
        <ModalTitle id="register-complement">{complementSelected ? 'Atualização de Complemento' : 'Cadastro de Complemento'}</ModalTitle>
      </ModalHeader>
      <ModalBody className='p-0'>
        <Wizard
          isHeader
          noValidate
          color='info'
          onSubmit={formik.handleSubmit}
          className='p-4 m-0'
          isLoading={isLoading}
        >
          <WizardItem id='step1' title='Informações do Complemento' required={checkStepIsValid('step1')}>
            <CardBody className='p-0 '>
              <div className='row gap-4'>
                <div className='d-flex align-items-center justify-content-center gap-4'>
                  <FormGroup
                    id='image_url'
                    ariaLabel='Logo'
                    label="Primária"
                  >
                    <Avatar
                      id='image_url'
                      value={formik.values.image_url}
                      onChange={handleImage} />
                  </FormGroup>

                  {settings?.ecommerce &&
                    <FormGroup
                      id='second_image_url'
                      ariaLabel='Logo'
                      label="Secundária"

                    >
                      <Avatar
                        id='second_image_url'
                        value={formik.values.second_image_url}
                        onChange={handleImageSecond} />
                    </FormGroup>
                  }

                </div>
                {/* Inputs */}
                <div className="row  pb-2 d-flex">
                  {/* Nome */}
                  <FormGroup id="name" label="Nome" className='col-md-8 mb-4'>
                    <Input
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.name}
                      isValid={formik.isValid}
                      isTouched={formik.touched.name}
                      invalidFeedback={formik.errors.name}
                      validFeedback='Assim está bom!'
                      placeholder='Eletrodomésticos, lâmpadas, etc...'
                    />
                  </FormGroup>

                  {/* Value */}
                  <FormGroup id="price" label="Preço" className='col-md-4 mb-4'>
                    <Input
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={masks.money(formik.values.price)}
                      isValid={formik.isValid}
                      isTouched={formik.touched.price}
                      invalidFeedback={formik.errors.price}
                      validFeedback='Assim está bom!'
                      placeholder='10,00'
                    />
                  </FormGroup>

                  {/* Ordem */}
                  <FormGroup id="order" label="Ordem de Exibição" className='col-md-4 mb-4'>
                    <Input
                      onChange={handleChangeOrder}
                      onBlur={formik.handleBlur}
                      value={formik.values.order || ''}
                      isValid={formik.isValid}
                      isTouched={formik.touched.order}
                      invalidFeedback={formik.errors.order}
                      validFeedback='Assim está bom!'
                      placeholder='1, 2, 3, 4 etc...'
                    />
                  </FormGroup>

                  {settings?.ecommerce &&

                    <FormGroup id="secondName" label="Nome Informativo" className='col-md-4 mb-4'>
                      <Input
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.secondName}
                        isValid={formik.isValid}
                        isTouched={formik.touched.secondName}
                        invalidFeedback={formik.errors.secondName}
                        validFeedback='Assim está bom!'
                        placeholder='Eletrodomésticos, lâmpadas, etc...'
                      />
                    </FormGroup>
                  }

                  <FormGroup id="sku" label="SKU" className='col-md-4 mb-4'>
                    <Input
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.sku}
                      isValid={formik.isValid}
                      isTouched={formik.touched.sku}
                      invalidFeedback={formik.errors.sku}
                      validFeedback='Assim está bom!'
                      placeholder='SKU'
                    />
                  </FormGroup>

                  {/* Ordem Delivery */}
                  <FormGroup id="orderDelivery" label="Ordem no Delivey" className='col-md-4 mb-4'>
                    <Input
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.orderDelivery || ''}
                      isValid={formik.isValid}
                      isTouched={formik.touched.orderDelivery}
                      invalidFeedback={formik.errors.orderDelivery}
                      validFeedback='Assim está bom!'
                      placeholder='Ex: 1'
                    />
                  </FormGroup>

                  {/* Cód Delivery */}
                  <FormGroup id="delivery_code" label="Cód Delivery" className='col-md-3 mb-4'>
                    <Input
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.delivery_code || ''}
                      isValid={formik.isValid}
                      isTouched={formik.touched.delivery_code}
                      invalidFeedback={formik.errors.delivery_code}
                      validFeedback='Assim está bom!'
                      placeholder='Ex: 1'
                    />
                  </FormGroup>

                  {/* Status */}
                  <FormGroup className='col-md-3 mb-4'>
                    <Label>Status</Label>
                    <ChecksGroup
                      className='d-flex gap-3 align-items-center mt-2'
                      isValid={formik.isValid}
                      isTouched={formik.touched.active}
                      invalidFeedback={formik.errors.active}
                    >
                      <Checks
                        type="radio"
                        id="active"
                        label="Ativo"
                        name="active"
                        value="ativo"
                        onChange={formik.handleChange}
                        checked={formik.values.active}
                        isInline
                        className='me-1'
                      />
                      <Checks
                        type="radio"
                        id="active2"
                        label="Inativo"
                        name="active"
                        value="inativo"
                        onChange={formik.handleChange}
                        checked={formik.values.active}
                        isInline
                        className='me-1'
                      />
                    </ChecksGroup>
                  </FormGroup>

                  {/* Descrição */}
                  <FormGroup id="description" label="Descrição" className='col-md-12 mb-4'>
                    <Textarea
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.description}
                      isTouched={formik.touched.description}
                      invalidFeedback={formik.errors.description}
                      validFeedback='Assim está bom!'
                      placeholder='Informe, se desejar, uma descrição para o complemento'
                    />
                  </FormGroup>

                  <div className='col-md-12 mb-1'>
                    <Label className='text-dark fw-bold text-uppercase small mb-0'>Características do complemento</Label>
                  </div>

                  <div className='col-md-4 mb-2'>
                    <div className='d-flex align-items-center gap-2 py-1'>
                      <ChecksGroup
                        isValid={formik.isValid}
                        isTouched={formik.touched.type_insume}
                        invalidFeedback={formik.errors.type_insume}
                      >
                        <Checks
                          type="checkbox"
                          id="type_insume"
                          name="type_insume"
                          value='check'
                          onChange={(e) => {
                            const isChecked = e.target.checked;
                            formik.setFieldValue('type_insume', isChecked ? ['check'] : []);
                          }}
                          checked={formik.values?.type_insume?.includes('check')}
                          isInline
                          className='me-1'
                        />
                      </ChecksGroup>
                      <Label htmlFor='type_insume' className='mb-0 text-dark'>Insumo ?</Label>
                    </div>
                  </div>

                </div>
              </div>
            </CardBody>
          </WizardItem>

          {showInsumesStep && (
            <WizardItem id='step2' title='Vincular Insumos'>
              <div className="row pb-2 d-flex p-2">
                <div className='col-md-11'>
                  <div className='d-flex align-items-end'>
                    <FormGroup id='insume' label='Insumo' className='col-md-5 mb-3 px-2'>
                      <Select
                        placeholder='Selecione o insumo'
                        list={noListedInsumes}
                        onChange={(e) => {
                          const id = e.target.value;
                          formik.setFieldValue('insume', id);
                          const findedInsume = noListedInsumes.find((i) => i.value == id)
                          formik.setFieldValue('insume_unit', findedInsume.unit);
                        }}
                        onBlur={formik.handleBlur}
                        value={formik.values.insume}
                      />
                    </FormGroup>

                    <FormGroup id='insume_unit' label='Unidade (Insumo)' className='col-md-3 mb-3 px-2'>
                      <Input
                        placeholder='tipo'
                        value={formik.values.insume_unit}
                        disabled
                        readOnly
                      />
                    </FormGroup>

                    <FormGroup id='insume_qtd' label='Quantidade' className='col-md-3 mb-3 px-2'>
                      <Input
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.insume_qtd}
                        isValid={formik.isValid}
                        isTouched={formik.touched.insume_qtd}
                        invalidFeedback={formik.errors.insume_qtd}
                        placeholder='100'
                        type='number'
                      />
                    </FormGroup>
                    <div className='col-md-1 mb-3 px-2 d-flex align-items-end'>
                      <Button
                        disabled={checkStepIsValid('add_insumo')}
                        color="primary"
                        icon="PlusCircle"
                        onClick={handleAddInsumeToProduct}
                        aria-label="Adicionar Insumo"
                      />
                    </div>
                  </div>
                </div>


                <div className="col-md-12">
                  {insumeToProduct?.length > 0 && (
                    <h6>Insumos adicionados</h6>
                  )}
                  {insumeToProduct?.map((product, index) => (
                    <div className='d-flex justify-content-center align-items-center py-1' key={index}>
                      <div className='d-flex'>
                        <FormGroup className='col-md-4 px-2'>
                          <Input
                            value={product.name}
                            disabled
                            readOnly
                          />
                        </FormGroup>

                        <FormGroup className='col-md-2 px-2'>
                          <Input
                            value={product.isNew ? product.qtd : convertGramaToKg(product.unit, product.qtd)}
                            disabled
                            readOnly
                          />
                        </FormGroup>

                        <FormGroup className='col-md-2 px-2'>
                          <Input
                            value={product.unit}
                            disabled
                            readOnly
                          />
                        </FormGroup>


                      </div>
                      <div className='d-flex justify-content-center align-items-center px-2'>
                        <Button
                          color="danger"
                          icon="Trash"
                          shadow="sm"
                          hoverShadow="sm"
                          size="sm"
                          onClick={() => handleRemoveInsume(index)}
                        />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </WizardItem>
          )}

          <WizardItem id='step3' title='Grupo Fiscal'>
            <div className='row pb-2 d-flex'>
              {(Array.isArray(formik.values.fiscal_groups_by_state) ? formik.values.fiscal_groups_by_state : [])
                .map((item, index, rows) => {
                  const selectedStates = rows.map(row => row?.state).filter(Boolean);
                  const stateOptions = brazilStates.map(option => ({
                    ...option,
                    disabled: selectedStates.includes(option.value) && option.value !== (item?.state || ''),
                  }));
                  const canAdd = [...new Set(selectedStates)].length < brazilStates.length;

                  return (
                    <React.Fragment key={`${item?.state || 'state'}-${item?.fiscal_group_id || 'group'}-${index}`}>
                      <FormGroup
                        id={`fiscal_groups_by_state[${index}].state`}
                        label='Estado'
                        className='col-md-6 mb-4'>
                        <Select
                          placeholder='Selecione'
                          value={item?.state || ''}
                          list={stateOptions}
                          onBlur={formik.handleBlur}
                          onChange={formik.handleChange}
                          isValid={formik.isValid}
                          isTouched={formik.submitCount > 0 || formik.touched?.fiscal_groups_by_state?.[index]?.state}
                          invalidFeedback={formik.errors?.fiscal_groups_by_state?.[index]?.state}
                        />
                      </FormGroup>

                      <div className='col-md-6 mb-4'>
                        <div className='d-flex gap-2 align-items-end'>
                          <FormGroup
                            id={`fiscal_groups_by_state[${index}].fiscal_group_id`}
                            label='Grupo Fiscal'
                            className='flex-grow-1 mb-0'>
                            <Select
                              placeholder='Selecione o grupo fiscal'
                              value={item?.fiscal_group_id || ''}
                              list={optionsFiscalGroups}
                              onBlur={formik.handleBlur}
                              onChange={formik.handleChange}
                              isValid={formik.isValid}
                              isTouched={formik.submitCount > 0 || formik.touched?.fiscal_groups_by_state?.[index]?.fiscal_group_id}
                              invalidFeedback={formik.errors?.fiscal_groups_by_state?.[index]?.fiscal_group_id}
                            />
                          </FormGroup>

                          <Button
                            color='danger'
                            icon='Trash'
                            shadow='sm'
                            hoverShadow='sm'
                            size='sm'
                            onClick={() => handleRemoveFiscalGroupByState(index)}
                          />

                          {index === rows.length - 1 && (
                            <Button
                              disabled={!canAdd}
                              color='dark'
                              icon='PlusCircle'
                              shadow='sm'
                              hoverShadow='sm'
                              size='sm'
                              onClick={handleAddFiscalGroupByState}
                            />
                          )}
                        </div>
                      </div>
                    </React.Fragment>
                  );
                })}
            </div>
          </WizardItem>

          <WizardItem id='step4' title='Informações Fiscais'>
            <div className="row  pb-2 d-flex">

              {/* Código de barras */}
              <FormGroup id='fiscal_data_bar_code' label='Código de barras' className='col-md-4 mb-4'>
                <Input
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.fiscal_data_bar_code}
                  isValid={formik.isValid}
                  isTouched={formik.touched.fiscal_data_bar_code}
                  invalidFeedback={formik.errors.fiscal_data_bar_code}
                  validFeedback='Assim está bom!'
                  placeholder='Ex: 7891234567890'
                  inputMode='numeric'
                />
              </FormGroup>

              {/* NCM */}
              <FormGroup id='fiscal_data_ncm' label='NCM' className='col-md-4 mb-4'>
                <Input
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.fiscal_data_ncm}
                  isValid={formik.isValid}
                  isTouched={formik.touched.fiscal_data_ncm}
                  invalidFeedback={formik.errors.fiscal_data_ncm}
                  validFeedback='Assim está bom!'
                  placeholder='Ex: 798632654214'

                />
              </FormGroup>

              {/* CST */}
              <FormGroup id='fiscal_data_cst' label='CST / ICMS' className='col-md-4 mb-4'>
                <Input
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.fiscal_data_cst}
                  isValid={formik.isValid}
                  isTouched={formik.touched.fiscal_data_cst}
                  invalidFeedback={formik.errors.fiscal_data_cst}
                  validFeedback='Assim está bom!'
                  placeholder='Ex: 798632654214'
                />
              </FormGroup>

              {/* CSOSN */}
              <FormGroup id='fiscal_data_csosn' label='CSOSN' className='col-md-4 mb-4'>
                <Input
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.fiscal_data_csosn}
                  isValid={formik.isValid}
                  isTouched={formik.touched.fiscal_data_csosn}
                  invalidFeedback={formik.errors.fiscal_data_csosn}
                  validFeedback='Assim está bom!'
                  placeholder='Ex: 798632654214'
                />
              </FormGroup>

              {/* CEST */}
              <FormGroup id='fiscal_data_cest' label='CEST' className='col-md-4 mb-4'>
                <Input
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.fiscal_data_cest}
                  isValid={formik.isValid}
                  isTouched={formik.touched.fiscal_data_cest}
                  invalidFeedback={formik.errors.fiscal_data_cest}
                  validFeedback='Assim está bom!'
                  placeholder='Ex: 798632654214'
                />
              </FormGroup>

              {/* CFOF */}
              <FormGroup id='fiscal_data_cfop' label='CFOP' className='col-md-4 mb-4'>
                <Input
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.fiscal_data_cfop}
                  isValid={formik.isValid}
                  isTouched={formik.touched.fiscal_data_cfop}
                  invalidFeedback={formik.errors.fiscal_data_cfop}
                  validFeedback='Assim está bom!'
                  placeholder='Ex: 798632654214'
                />
              </FormGroup>

              {/* <FormGroup id='fiscal_data_sku' label='SKU' className='col-md-4 mb-4'>
                <Input
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.fiscal_data_sku}
                  isValid={formik.isValid}
                  isTouched={formik.touched.fiscal_data_sku}
                  invalidFeedback={formik.errors.fiscal_data_sku}
                  validFeedback='Assim está bom!'
                  placeholder='Ex: 12445'
                />
              </FormGroup> */}
              <FormGroup id='fiscal_data_pis' label='PIS' className='col-md-4 mb-4'>
                <Input
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.fiscal_data_pis}
                  isValid={formik.isValid}
                  isTouched={formik.touched.fiscal_data_pis}
                  invalidFeedback={formik.errors.fiscal_data_pis}
                  validFeedback='Assim está bom!'
                  placeholder='Ex: 798632654214'
                />
              </FormGroup>

              <FormGroup id='fiscal_data_cofins' label='COFINS' className='col-md-4 mb-4'>
                <Input
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.fiscal_data_cofins}
                  isValid={formik.isValid}
                  isTouched={formik.touched.fiscal_data_cofins}
                  invalidFeedback={formik.errors.fiscal_data_cofins}
                  validFeedback='Assim está bom!'
                  placeholder='Ex: 798632654214'
                />
              </FormGroup>

              <FormGroup id='fiscal_data_cBenef' label='Código de Benefício Fiscal' className='col-md-4 mb-4'>
                <Input
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.fiscal_data_cBenef}
                  isValid={formik.isValid}
                  isTouched={formik.touched.fiscal_data_cBenef}
                  invalidFeedback={formik.errors.fiscal_data_cBenef}
                  validFeedback='Assim está bom!'
                  placeholder='Ex: RS123456'
                />
              </FormGroup>

              <FormGroup id='fiscal_data_cClassTrib' label='Classificação Tributária CBS/IBS' className='col-md-4 mb-4'>
                <Input
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.fiscal_data_cClassTrib}
                  isValid={formik.isValid}
                  isTouched={formik.touched.fiscal_data_cClassTrib}
                  invalidFeedback={formik.errors.fiscal_data_cClassTrib}
                  validFeedback='Assim está bom!'
                  placeholder='Ex: 798632654214'
                />
              </FormGroup>

              <FormGroup id='fiscal_data_cst_cbs_ibs' label='CST CBS/IBS' className='col-md-4 mb-4'>
                <Input
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.fiscal_data_cst_cbs_ibs}
                  isValid={formik.isValid}
                  isTouched={formik.touched.fiscal_data_cst_cbs_ibs}
                  invalidFeedback={formik.errors.fiscal_data_cst_cbs_ibs}
                  validFeedback='Assim está bom!'
                  placeholder='Ex: 798632654214'
                />
              </FormGroup>

              <FormGroup id='fiscal_data_percentualReducao' label='Redução IBS/CBS' className='col-md-4 mb-4'>
                <Input
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.fiscal_data_percentualReducao}
                  isValid={formik.isValid}
                  isTouched={formik.touched.fiscal_data_percentualReducao}
                  invalidFeedback={formik.errors.fiscal_data_percentualReducao}
                  validFeedback='Assim está bom!'
                  placeholder='Ex: 798632654214'
                />
              </FormGroup>

              <FormGroup id='fiscal_data_pRedICMS' label='Redução da Base do ICMS (%)' className='col-md-4 mb-4'>
                <Input
                  type='number'
                  min='0'
                  max='100'
                  step='0.01'
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.fiscal_data_pRedICMS}
                  isValid={formik.isValid}
                  isTouched={formik.touched.fiscal_data_pRedICMS}
                  invalidFeedback={formik.errors.fiscal_data_pRedICMS}
                  placeholder='Ex.: 40'
                />
              </FormGroup>

        

              {
                <>
                  {/* Aliquota ICMS */}
                  <FormGroup id='fiscal_data_aliq_icms' label='Alíquota ICMS' className='col-md-4 mb-4'>
                    <Input
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.fiscal_data_aliq_icms}
                      isValid={formik.isValid}
                      isTouched={formik.touched.fiscal_data_aliq_icms}
                      invalidFeedback={formik.errors.fiscal_data_aliq_icms}
                      validFeedback='Assim está bom!'
                      placeholder='Ex: 18.00'
                    />
                  </FormGroup>
                </>
              }

            </div>
          </WizardItem>
        </Wizard>
      </ModalBody>
    </Modal>
  )
}

export default ModalRegisterComplement;
